// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RegionalPreRelease } from './RegionalPreRelease';
import {
  RegionalPreReleaseFromJSON,
  RegionalPreReleaseFromJSONTyped,
  RegionalPreReleaseToJSON,
  RegionalPreReleaseToJSONTyped,
} from './RegionalPreRelease';

/**
 *
 * @export
 * @interface SetRegionalPreRelease200Response
 */
export interface SetRegionalPreRelease200Response {
  /**
   *
   * @type {RegionalPreRelease}
   * @memberof SetRegionalPreRelease200Response
   */
  data: RegionalPreRelease;
}

/**
 * Check if a given object implements the SetRegionalPreRelease200Response interface.
 */
export function instanceOfSetRegionalPreRelease200Response(
  value: object,
): value is SetRegionalPreRelease200Response {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function SetRegionalPreRelease200ResponseFromJSON(
  json: any,
): SetRegionalPreRelease200Response {
  return SetRegionalPreRelease200ResponseFromJSONTyped(json, false);
}

export function SetRegionalPreRelease200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetRegionalPreRelease200Response {
  if (json == null) {
    return json;
  }
  return {
    data: RegionalPreReleaseFromJSON(json['data']),
  };
}

export function SetRegionalPreRelease200ResponseToJSON(
  json: any,
): SetRegionalPreRelease200Response {
  return SetRegionalPreRelease200ResponseToJSONTyped(json, false);
}

export function SetRegionalPreRelease200ResponseToJSONTyped(
  value?: SetRegionalPreRelease200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: RegionalPreReleaseToJSON(value['data']),
  };
}
